module.exports = __webpack_public_path__ + "static/media/quickbooks-icon.d700db9e.svg";